module.exports = __webpack_public_path__ + "img/kitchen_dark.f1204843.png";